const animation = {
    v: "5.9.0",
    fr: 50,
    ip: 0,
    op: 112,
    w: 400,
    h: 400,
    nm: "spinnerColorXS",
    ddd: 0,
    assets: [],
    layers: [
        {
            ddd: 0,
            ind: 1,
            ty: 4,
            nm: "circle",
            sr: 1,
            ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: {
                    a: 1,
                    k: [
                        {
                            i: { x: 0.667, y: 1 },
                            o: { x: 0.333, y: 0 },
                            t: 10,
                            s: [202, 200, 0],
                            to: [0, 0, 0],
                            ti: [0, 0, 0],
                        },
                        {
                            i: { x: 0.833, y: 0.833 },
                            o: { x: 0.333, y: 0.333 },
                            t: 26,
                            s: [202, 242, 0],
                            to: [0, 0, 0],
                            ti: [0, 0, 0],
                        },
                        {
                            i: { x: 0.667, y: 1 },
                            o: { x: 0.333, y: 0 },
                            t: 46,
                            s: [202, 242, 0],
                            to: [0, 0, 0],
                            ti: [0, 0, 0],
                        },
                        { t: 58, s: [202, 200, 0] },
                    ],
                    ix: 2,
                    l: 2,
                },
                a: { a: 0, k: [2, 0, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
            },
            ao: 0,
            shapes: [
                {
                    ind: 0,
                    ty: "sh",
                    ix: 1,
                    ks: {
                        a: 1,
                        k: [
                            {
                                i: { x: 0.62, y: 1 },
                                o: { x: 0.85, y: 0 },
                                t: 0,
                                s: [
                                    {
                                        i: [
                                            [-98.859, 0],
                                            [0, -98.859],
                                            [98.859, 0],
                                            [0, 98.859],
                                        ],
                                        o: [
                                            [98.859, 0],
                                            [0, 98.859],
                                            [-98.859, 0],
                                            [0, -98.859],
                                        ],
                                        v: [
                                            [2, -179],
                                            [181, 0],
                                            [2, 179],
                                            [-177, 0],
                                        ],
                                        c: true,
                                    },
                                ],
                            },
                            {
                                i: { x: 0.62, y: 1 },
                                o: { x: 0.85, y: 0 },
                                t: 25.84,
                                s: [
                                    {
                                        i: [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                        ],
                                        o: [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                        ],
                                        v: [
                                            [0, -180.234],
                                            [76.744, -47.309],
                                            [153.489, 85.617],
                                            [-153.489, 85.617],
                                        ],
                                        c: true,
                                    },
                                ],
                            },
                            {
                                i: { x: 0.62, y: 1 },
                                o: { x: 0.85, y: 0 },
                                t: 37,
                                s: [
                                    {
                                        i: [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                        ],
                                        o: [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                        ],
                                        v: [
                                            [0, -180.234],
                                            [76.744, -47.309],
                                            [153.489, 85.617],
                                            [-153.489, 85.617],
                                        ],
                                        c: true,
                                    },
                                ],
                            },
                            {
                                i: { x: 0.62, y: 1 },
                                o: { x: 0.167, y: 0 },
                                t: 68,
                                s: [
                                    {
                                        i: [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                        ],
                                        o: [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                        ],
                                        v: [
                                            [127, -130],
                                            [127, 122],
                                            [-125, 122],
                                            [-125, -130],
                                        ],
                                        c: true,
                                    },
                                ],
                            },
                            {
                                i: { x: 0.62, y: 1 },
                                o: { x: 0.85, y: 0 },
                                t: 81,
                                s: [
                                    {
                                        i: [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                        ],
                                        o: [
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                            [0, 0],
                                        ],
                                        v: [
                                            [127, -130],
                                            [127, 122],
                                            [-125, 122],
                                            [-125, -130],
                                        ],
                                        c: true,
                                    },
                                ],
                            },
                            {
                                i: { x: 0.62, y: 1 },
                                o: { x: 0.85, y: 0 },
                                t: 104,
                                s: [
                                    {
                                        i: [
                                            [-98.859, 0],
                                            [0, -98.859],
                                            [98.859, 0],
                                            [0, 98.859],
                                        ],
                                        o: [
                                            [98.859, 0],
                                            [0, 98.859],
                                            [-98.859, 0],
                                            [0, -98.859],
                                        ],
                                        v: [
                                            [2, -179],
                                            [181, 0],
                                            [2, 179],
                                            [-177, 0],
                                        ],
                                        c: true,
                                    },
                                ],
                            },
                            {
                                t: 112,
                                s: [
                                    {
                                        i: [
                                            [-98.859, 0],
                                            [0, -98.859],
                                            [98.859, 0],
                                            [0, 98.859],
                                        ],
                                        o: [
                                            [98.859, 0],
                                            [0, 98.859],
                                            [-98.859, 0],
                                            [0, -98.859],
                                        ],
                                        v: [
                                            [2, -179],
                                            [181, 0],
                                            [2, 179],
                                            [-177, 0],
                                        ],
                                        c: true,
                                    },
                                ],
                            },
                        ],
                        ix: 2,
                    },
                    nm: "Tracé 1",
                    mn: "ADBE Vector Shape - Group",
                    hd: false,
                },
                {
                    ty: "fl",
                    c: {
                        a: 1,
                        k: [
                            {
                                i: { x: [0.833], y: [0.999] },
                                o: { x: [0.167], y: [0.001] },
                                t: 0,
                                s: [0.254901975393, 0.54509806633, 0.360784322023, 1],
                            },
                            {
                                i: { x: [0.833], y: [1] },
                                o: { x: [0.167], y: [0] },
                                t: 26,
                                s: [1, 0.666666686535, 0.050980392843, 1],
                            },
                            {
                                i: { x: [0.833], y: [1] },
                                o: { x: [0.167], y: [0] },
                                t: 37,
                                s: [1, 0.666666686535, 0.050980392843, 1],
                            },
                            {
                                i: { x: [0.833], y: [1] },
                                o: { x: [0.167], y: [0] },
                                t: 68,
                                s: [1, 0.764705896378, 0.874509811401, 1],
                            },
                            {
                                i: { x: [0.833], y: [1] },
                                o: { x: [0.167], y: [0] },
                                t: 81,
                                s: [1, 0.764705896378, 0.874509811401, 1],
                            },
                            { t: 104, s: [0.254901975393, 0.54509806633, 0.360784322023, 1] },
                        ],
                        ix: 4,
                    },
                    o: { a: 0, k: 100, ix: 5 },
                    r: 1,
                    bm: 0,
                    nm: "Riempimento 1",
                    mn: "ADBE Vector Graphic - Fill",
                    hd: false,
                },
            ],
            ip: 0,
            op: 750,
            st: 0,
            bm: 0,
        },
    ],
    markers: [],
};
export default animation;
//# sourceMappingURL=spinnerColorXS.js.map